<template>
  <div class="sellermoney-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <DatePicker type="daterange"
                      format="yyyy-MM-dd"
                      split-panels
                      @on-change="changeDate"
                      style="width: 200px"
                      placeholder="开始时间 - 结束时间"></DatePicker>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入供应商名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.order_sn"
                 clearable
                 placeholder="订单编号..."></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.sorce"
                  :style="{'width':'150px'}"
                  placeholder="订单来源..."
                  clearable>
            <Option v-for="item in shipStatusList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Modal v-model="showTxModalStatus"
           title="修改提现"
           @on-ok="editTx('txInfoValidate')"
           :loading="loading">
      <Form :model="txInfo"
            action="javascript:void(0)"
            ref="txInfoValidate"
            :rules="txInfoValidate">
        <FormItem label="状态"
                  prop="status">
          <RadioGroup v-model="txInfo.tx_status">
            <Radio :label="0"
                   border>待体现</Radio>
            <Radio :label="1"
                   border>部分提现</Radio>
            <Radio :label="2"
                   border>已提现</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="提现金额"
                  prop="tx_price">
          <Input v-model="txInfo.tx_price"
                 placeholder="排序"></Input>
        </FormItem>
      </Form>

    </Modal>
  </div>
</template>

<script>
export default {
  name: "sellermoney-list",
  data () {
    return {
      tradesman: {},
      loading: true,
      dataloading: true,
      showTxModalStatus: false,
      datetime: [],
      title: "",
      shipStatusList: [
        { value: 0, label: "商城" },
        { value: 2, label: "盲盒" }
      ],
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: "",
        order_sn: "",
      },
      list: [
        {
          title: "订单编号",
          key: "order_num",
          width: 290
        },
        {
          title: "商家名称",
          key: "name",
          width: 150
        },
        {
          title: "收入来源",
          key: "income_sorce",
          width: 90
        },
        {
          title: "订单金额",
          key: "order_price",
          width: 100
        },
        {
          title: "供应商货款",
          key: "prices",
          width: 100
        },
        {
          title: "平台利润",
          key: "plat",
          width: 100
        },
        {
          title: "订单状态",
          key: "order_status",
          width: 150
        },
        {
          title: "下单用户",
          key: "user",
          width: 150
        },
        {
          title: "下单时间",
          key: "order_time",
          width: 150
        },
        {
          title: "到账时间",
          key: "created_at",
          width: 150
        },
        {
          title: "提现状态",
          width: 90,
          key: "tx_status",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.tx_status == 1
                  ? "部分呢提现"
                  : params.row.tx_status == 2
                    ? "已提现"
                    : "待提现"
              )
            ]);
          }
        },
        {
          title: "提现金额",
          key: "tx_price",
          width: 150
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.txDetail(params.row.id, params.index);
                    }
                  }
                },
                "提现状态"
              ),
            ]);
          }
        }
      ],
      reviewOrder: {},
      tablelist: [],
      showModalStatus: false,
      txInfo: {
        tx_status: 0,
        tx_price: 0
      },
      txInfoValidate: {},
    };
  },
  created: function () {
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      this.$api.sellermoney
        .list({ page: this.pages.page, size: this.pages.size })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    //提现
    txDetail (id, index) {
      this.txInfo = {
        tx_status: index.tx_status,
        tx_price: index.tx_price,
        id: id,
      };
      this.showTxModalStatus = !this.showTxModalStatus;
    },
    editTx (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$api.sellermoney.txstatus({
            id: this.txInfo.id,
            tx_status: this.txInfo.tx_status,
            tx_price: this.txInfo.tx_price
          }).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showTxModalStatus = !this.showTxModalStatus;
          });
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      })
    },
    changeDate (val) {
      this.datetime = val;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      var starttime = this.datetime[0] != undefined ? this.datetime[0] : "";
      var endtime = this.datetime[1] != undefined ? this.datetime[1] : "";
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        starttime: starttime,
        sorce: this.formItem.sorce,
        endtime: endtime,
        order_sn: this.formItem.order_sn,
      };
      this.$api.sellermoney.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
        }
      });
      return;
    }
  }
};
</script>